export const singleConfig = {
  1: {
    key: 'article'
  },
  2: {
    key: 'live'
  },
  3: {
    key: 'album'
  },
  4: {
    key: 'wk'
  },
  5: {
    key: 'album'
  }
}

export const coverDefault = require('./images/r.png')

const env = process.env.VUE_APP_ENV

const _zsldConfig = {
  test: {
    appId: 'wxc1e327cb613215b6',
    authHost: 'https://test-fw-api.jindashi.cn',
    zscsHost: 'https://test-api.zscaishang.com'
  },
  preview: {
    appId: 'wxa2985b72e4bcbef2',
    authHost: 'https://fw-api.jindashi.cn',
    zscsHost: 'https://pre-api.zscaishang.com'
  },
  production: {
    appId: 'wxa2985b72e4bcbef2',
    authHost: 'https://fw-api.jindashi.cn',
    zscsHost: 'https://api.zscaishang.com'
  }
}
export const ZSLD_CONFIG = _zsldConfig[env || 'test']

export const AUTH_DESC = {
  course: `<p>您没有访问此课程的权限，如有开通需要请联系您的班主任！</p>`,
  service: `<p>您没有访问此服务的权限，如有开通需要请联系您的班主任！</p>`,
  class: `<p>本课程需要报道后激活，请联系您的班主任</p>`
}
